import React, { useState } from 'react';

function ButtonHover (props) {

  const [hoverButton, setHoverButton] = useState({
    padding: '20px 40px',
    margin: '20px',
    border: '1px solid #fff',
    borderRadius: '4px',
    textTransform: 'uppercase',
    fontWeight: '400',
    textAlign: 'center',
    background: '#80a3db',
    color: '#fff',
    textDecoration: 'none',
  });

  return(
      <div style={{
          height: '50px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <button
          style={hoverButton}
          onMouseEnter={() => setHoverButton({
            padding: '20px 40px',
            margin: '20px',
            border: '1px solid #fff',
            borderRadius: '4px',
            textTransform: 'uppercase',
            fontWeight: '400',
            textAlign: 'center',
            background: '#fff',
            color: '#80a3db',
            textDecoration: 'none',
          })}
          onMouseLeave={() => setHoverButton({
            padding: '20px 40px',
            margin: '20px',
            border: '1px solid #fff',
            borderRadius: '4px',
            textTransform: 'uppercase',
            fontWeight: '400',
            textAlign: 'center',
            background: '#80a3db',
            color: '#fff',
            textDecoration: 'none',
          })}
          >{props.buttonName}
        </button>
    </div>
  )
}

export default ButtonHover
